import { Base } from "../../core/base.model";
import { Proyecto } from "../proyecto";
import { EstrategiaSeguir } from "./estrategia-aseguir.model";
import { FaseDeteccion } from "./fase-deteccion.model";
import { Impacto } from "./impacto.model";
import { Periodicidad } from "./periodicidad.model";
import { Probabilidad } from "./probabilidad.model";
import { SeveridadRiesgo } from "./severidad-riesgo.model";
import { TipoRiesgo } from "./tipo-riesgo.model";

export class Riesgos extends Base{
    id: number;
    id_fase_deteccion: number;
    descripcion: string;
    causa_raiz: string;
    id_tipo_riesgo: number;
    id_probabilidad: number;
    id_impacto: number;
    id_severidad: number;
    id_estrategia: number;
    fecha_identificacion: Date;
    id_periodicidad: number;
    acciones_seguir: string;
    responsable_recurso: string;
    id_proyecto: string;
    estatus: boolean;
    calculo_severidad: number;
    id_area: number;

    faseDeteccion: FaseDeteccion;
    tipoRiesgo: TipoRiesgo;
    probabilidad: Probabilidad;
    severidad: SeveridadRiesgo;
    estrategia: EstrategiaSeguir;
    periodicidad: Periodicidad;
    proyecto: Proyecto;
    impacto: Impacto;
}